import { createCommand } from '../../utils';
import { displayDegradations, moduleName } from '../state';
import { userOrganizationQuery } from '../../authentication/queries';

export const SetDisplayDegradationsFromPersistenceCommand = createCommand(
    `${moduleName}/SET_DISPLAY_DEGRADATIONS_FROM_PERSISTANCE`,
    async (_, { dispatch, extra, getState }) => {
        const userOrganization = userOrganizationQuery(getState());

        if (userOrganization) {
            const organizationSettings = await extra.mapViewSettings.getSettingsByOrganizationId(userOrganization.id);
            if (typeof organizationSettings.displayDegradations !== 'undefined') {
                dispatch(displayDegradations(organizationSettings.displayDegradations));
            }
        }
    },
);
